import { render } from "./LeeCollapseItem.vue?vue&type=template&id=773468cc"
import script from "./LeeCollapseItem.vue?vue&type=script&lang=js"
export * from "./LeeCollapseItem.vue?vue&type=script&lang=js"

import "./LeeCollapseItem.vue?vue&type=style&index=0&id=773468cc&lang=css"

import exportComponent from "F:\\leeao\\leeplus_docs_code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__